import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectAffectionDepartment } from "../Model/ProposalProjectAffectionDepartment";

export async function createProposalProjectAffectionDepartment(data) {
	let response = await getAPIResponse("/v1/proposal-project-affection/add", data, "POST");
	if (response === null) {
		return null;
	}
	let proposalProjectAffectionDepartment = ProposalProjectAffectionDepartment.createFromResponseData(response);
	return proposalProjectAffectionDepartment;
}
